import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { NamedLink } from '../../../../components';
import css from './BlackSection.module.css';
import buttonCss from '../HomepageButtons.module.css';

const BlackSection = () => (
  <section className={css.root}>
    <div className={css.outer}>
      <div className={css.content}>
        <p className={css.eyebrow}>About Unvarnished</p>
        <h2 className={css.title}>
          I built this because online shopping shouldn't feel like a guessing game.
        </h2>
        <p className={css.body}>
          Colors that look nothing like the photos. Sizing that's anybody's guess. I was tired of it
          and figured most women were too. So I built Unvarnished: honest reviews from real women
          who'd actually worn the thing.
        </p>
        <p className={css.body}>
          The resale side came naturally. If we already knew which brands were worth owning, why not
          help move the ones we'd outgrown? Other platforms became cluttered free-for-alls with
          payouts that would make you cry. We keep it simple: real pieces, honest descriptions, 80%
          back to you.
        </p>
        <NamedLink
          name="AboutPage"
          className={`${buttonCss.button} ${buttonCss.buttonPrimary} ${buttonCss.buttonDark}`}
        >
          <ArrowUpRight aria-hidden="true" className={buttonCss.icon} strokeWidth={2} />
          <span>READ MORE</span>
        </NamedLink>
      </div>
    </div>
  </section>
);

export default BlackSection;
